import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-helpbutton-staffs',
  templateUrl: './helpbutton-staffs.component.html',
  styleUrls: ['./helpbutton-staffs.component.scss']
})
export class HelpbuttonStaffsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
